/*
Estos son los tipos de errores que existen, emprezamos a contar en el uno.
*/
export const ExcepcionTipoGlobal = {
    arr: ['', 'Metodo', 'Servicio', 'Conexión', 'SQL']
};
